import * as URL from "../helpers/Constants";
import axios from "axios";

export default class AffiliateService {


    static getAllAffiliate(params) {
        return axios.get(URL.GET_ALL_AFFILIATE_URL, {
            ...AffiliateService.getAuthHeader(),
            params
        });
    }

    static getAllCommission(params) {
        return axios.get(URL.GET_ALL_COMMISSIONS_URL, {
            ...AffiliateService.getAuthHeader(),
            params
        });
    }

    static getAffiliateById(id) {
        return axios.get(`${URL.GET_AFFILIATE_BY_ID_uRL}/${id}`, AffiliateService.getAuthHeader());
    }

    static addAffiliate(data, pharmacyOwnerId) {

        return axios.post(URL.CREATE_AFFILIATE_URL, data, {
            ...AffiliateService.getAuthHeader(),
            params: {pharmacyOwnerId}
        });
    }

    static updateAffiliate(data, id) {
        return axios.put(`${URL.UPDATE_AFFILIATE_URL}/${id}`, data, AffiliateService.getAuthHeader());
    }


    static disableOrEnableAffiliate(disable, id) {
        return axios.put(`${URL.ENABLE_DISABLE_AFFILIATE_URL}/${id}`, null, {
            ...AffiliateService.getAuthHeader(),
            params: {disable}
        });
    }

    static changeAffiliateUserPasswordById(data, id) {
        return axios.put(`${URL.CHANGE_AFFILIATE_USER_PASSWORD_BY_ID}/${id}`, data, AffiliateService.getAuthHeader());
    }

    static getAffiliateReport(params) {
        return axios({
            url: `${URL.GET_WITHDRAW_REPORT_EXCELL_URL}`,
            params,
            method: "GET",
            responseType: "blob", // Important,
            ...AffiliateService.getAuthHeaderForFileDownload(),
        });
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }


    static getAuthHeaderForFileDownload = () => {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Response-Type": "blob",
            },
        };
    };


}